import {
  Diseases,
  type DiseaseType,
  Findings,
  type FindingType,
} from "../mappers";

export type LookupRule = {
  inputFindings: FindingType[];
  recommendedDiseases: DiseaseType[];
};

export const PREDEFINED_LOOKUP_RULES: LookupRule[] = [
  {
    inputFindings: [],
    recommendedDiseases: [],
  },
  {
    inputFindings: [Findings.fever],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid],
  },
  {
    inputFindings: [Findings.fever, Findings.headache],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.cough],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.vomiting],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.headache, Findings.cough],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.diarrhoea],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid],
  },
  {
    inputFindings: [Findings.fever, Findings.headache, Findings.vomiting],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.cough, Findings.vomiting],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.chest_pain],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.rash],
    recommendedDiseases: [Diseases.typhoid, Diseases.dengue, Diseases.malaria],
  },
  {
    inputFindings: [Findings.fever, Findings.headache, Findings.chest_pain],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.cough, Findings.diarrhoea],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid],
  },
  {
    inputFindings: [Findings.fever, Findings.cough, Findings.chest_pain],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.headache, Findings.diarrhoea],
    recommendedDiseases: [Diseases.malaria, Diseases.typhoid, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.breathless],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.breathless],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.stomach_pain],
    recommendedDiseases: [
      Diseases.typhoid,
      Diseases.malaria,
      Diseases.uti,
      Diseases.dengue,
    ],
  },
  {
    inputFindings: [Findings.fever, Findings.cough, Findings.breathless],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
  {
    inputFindings: [Findings.fever, Findings.headache, Findings.stomach_pain],
    recommendedDiseases: [
      Diseases.typhoid,
      Diseases.malaria,
      Diseases.uti,
      Diseases.dengue,
    ],
  },
  {
    inputFindings: [Findings.fever, Findings.pain_on_passing_urine],
    recommendedDiseases: [
      Diseases.uti,
      Diseases.malaria,
      Diseases.typhoid,
      Diseases.dengue,
    ],
  },
  {
    inputFindings: [Findings.fever, Findings.muscle_ache],
    recommendedDiseases: [Diseases.typhoid, Diseases.malaria, Diseases.dengue],
  },
];
